import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useReorderPortfolioCategories = () => {
  const mutation = trpc.portfolioManagement.categories.reorder.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, reorderCategories: action.execute };
};
